import { Circle, Separator, HStack, Icon, IconButton, Link } from '@chakra-ui/react'
import { CardCarouselControlProps } from '@src/components/sco/CardCarousel/Controls/CardCarouselControlProps'
import React, { useEffect, useState } from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { MdOutlinePause, MdPlayArrow } from 'react-icons/md'

export const MobileBottomControl = (props: CardCarouselControlProps) => {
  return (
    <HStack align={'center'} gap={0} justify={'center'} paddingTop={2}>
      <HStack>
        <HStack>
          <IconButton
            aria-label={'Previous Item'}
            disabled={props.activeItemIndex === 0}
            size={'sm'}
            title={'Previous Item'}
            variant={'ghost'}
            _hover={{
              bgColor: 'none',
            }}
            onClick={() => props.prevItem()}
          >
            <Icon asChild boxSize={4}>
              <FiChevronLeft />
            </Icon>
          </IconButton>
          {props.pages.map((_, i) => (
            <Link
              key={i}
              display={'block'}
              opacity={i === props.activePageIndex ? 1 : 0.3}
              _hover={{
                opacity: 1,
              }}
              onClick={() => props.goToPage(i)}
            >
              <Circle
                bgColor={'actionPrimary'}
                boxShadow={i === props.activePageIndex ? '0px 0px 6px #AFC5E8' : 'none'}
                margin={'0.2em'}
                size={'0.4em'}
              />
            </Link>
          ))}
          <IconButton
            aria-label={'Next Item'}
            disabled={props.activeItemIndex === props.items.length - 1}
            size={'sm'}
            title={'Next Item'}
            variant={'ghost'}
            _hover={{
              bgColor: 'none',
            }}
            onClick={() => props.nextItem()}
          >
            <Icon asChild boxSize={4}>
              <FiChevronRight />
            </Icon>
          </IconButton>
        </HStack>
        <Separator borderColor={'backgroundTertiary'} height={'1em'} orientation={'vertical'} />
        {props.autoCycleState.isDisabled === false && <AutoCycleControl {...props} />}
      </HStack>
    </HStack>
  )
}

export const AutoCycleControl = (props: CardCarouselControlProps) => {
  const [nextTransitionAt, setNextTransitionAt] = useState(null)

  useEffect(() => {
    if (!props.autoCycleState.isPaused) {
      setNextTransitionAt(props.autoCycleState.nextTransitionAt)
    }
  }, [props.autoCycleState.nextTransitionAt])

  return (
    <HStack align={'center'} gap={1}>
      {/* <CircularProgress
        key={`progress-${props.autoCycleState.nextTransitionAt.toString()}-${
          props.autoCycleState.isPaused ? 'paused' : 'active'
        }`}
        color={'white'}
        size={4}
        sx={{ circle: { transition: `all ${props.autoCycleState.delay}ms ease-out !important` } }}
        thickness={12}
        trackColor="transparent"
        value={
          props.autoCycleState.isPaused || nextTransitionAt == props.autoCycleState.nextTransitionAt
            ? 100
            : 0
        }
      /> */}
      {props.autoCycleState.isPaused ? (
        <IconButton
          aria-label={'Play'}
          size={'sm'}
          title={'Play'}
          variant={'ghost'}
          _hover={{
            bgColor: 'none',
          }}
          onClick={() => props.updateAutoCycleState({ isPaused: false })}
        >
          <Icon asChild boxSize={4}>
            <MdPlayArrow />
          </Icon>
        </IconButton>
      ) : (
        <IconButton
          aria-label={'Pause'}
          size={'sm'}
          title={'Pause'}
          variant={'ghost'}
          _hover={{
            bgColor: 'none',
          }}
          onClick={() => props.updateAutoCycleState({ isPaused: true })}
        >
          <Icon asChild boxSize={4}>
            <MdOutlinePause />
          </Icon>
        </IconButton>
      )}
    </HStack>
  )
}
